<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>询价单详情</el-breadcrumb-item>
            </el-breadcrumb>

        </div>

        <div class="swb-back-row">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>询价标题</label>
                    </div>
                    <div class="form-value">
                        <div class="">{{priceInpryInfo.form - label}}</div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>被询价方</label>
                    </div>
                    <div class="form-value">
                        <div class="">{{priceInpryInfo.peerMerchantName}}</div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>询价时间</label>
                    </div>
                    <div class="form-value">
                        <div class="">{{priceInpryInfo.publishTime}}</div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>截至日期</label>
                    </div>
                    <div class="form-value">
                        <div class="">{{priceInpryInfo.expireDate}}</div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>要求交付期</label>
                    </div>
                    <div class="form-value">
                        <div class="" v-if="priceInpryInfo.deliverPeriod != null">{{priceInpryInfo.deliverPeriod}}&nbsp;&nbsp;天</div>
                        <div v-else>无</div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>联系人</label>
                    </div>
                    <div class="form-value">
                        <div class="">{{priceInpryInfo.contactName}}</div>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>联系电话</label>
                    </div>
                    <div class="form-value">
                        <div class="">{{priceInpryInfo.contactTel}}</div>
                    </div>
                </div>
                <div class="form-group center" v-if="priceInpryInfo.goodsFlag==true">
                    <div class="form-label">
                        <label>询价商品</label>
                    </div>
                    <div class="form-value">
                        <div class="table-layout">
                            <el-table :data="priceInpryInfo.goodsList" border style="width: 100%;">
                                <el-table-column prop="goodsImage" width="150" label="商品图片" align="center">
                                    <template slot-scope="rows">
                                        <img :src="rows.row.goodsImage"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                                <el-table-column prop="quantity" label="数量" width="100" align="center"></el-table-column>
                                <el-table-column prop="price" label="市场单价(元)" width="150" align="center">
                                    <template slot-scope="rows">
                                        <span v-if="rows.row.priceNegoFlag==0">{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                        <span v-if="rows.row.priceNegoFlag==1">面议</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="total" label="小计(元)" width="200" align="center">
                                    <template slot-scope="rows">
                                        <span v-if="rows.row.priceNegoFlag==0">{{parseFloat(rows.row.quantity * rows.row.price).toFixed(2)}}</span>
                                        <span v-if="rows.row.priceNegoFlag==1">面议</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="caozuo" label="操作" width="100" align="center">
                                    <template slot-scope="rows">
                                        <a class="swb-btn-link" @click="toPriceComparison(rows.row.id,rows.row.skuId)">比价</a>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>

                <div class="form-group center" v-if="priceInpryInfo.servcFlag==true">
                    <div class="form-label">
                        <label>询价服务</label>
                    </div>
                    <div class="form-value">
                        <div class="table-layout">
                            <el-table :data="priceInpryInfo.servcList" border style="width: 100%;">
                                <el-table-column prop="servcImage" width="150" label="服务图片" align="center">
                                    <template slot-scope="rows">
                                        <img :src="rows.row.servcImage"/>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="服务名称" align="center"></el-table-column>
                                <el-table-column prop="price" label="市场单价(元)" width="150" align="center">
                                    <template slot-scope="rows">
                                        <span>{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="total" label="小计(元)" width="200" align="center">
                                    <template slot-scope="rows">
                                        <span>{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="caozuo" label="操作" width="100" align="center">
                                    <template slot-scope="rows">
                                        <a class="swb-btn-link" @click="toServcComparison(rows.row.id,rows.row.ssuId)">比价</a>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>交易规则</label>
                    </div>
                    <div class="form-value">
                        <swb-create-trade-rule v-if="forGoods != null || forServc != null" :comparedTradeRuleList="comparedTradeRuleList" :type="type" :operate="tradeOperate" :forPriceInqry="forPriceInqry" :forGoods="forGoods" :forServc="forServc" ref="swb_create_trade_rule"></swb-create-trade-rule>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-toolbar" @click="goBack()">
            <button class="swb-btn swb-btn-small swb-btn-primary">返回</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import priceApi from '../../api/price'

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);

    import SwbPriceComparison from './PriceComparison';
    Routes.add(SwbPriceComparison);
    import SwbServcComparison from './ServcComparison';
    Routes.add(SwbServcComparison);
    import SwbPriceInpryList from './PriceInpryList';
    Routes.add(SwbPriceInpryList);

    export default{
        name: 'swb-price-inpry-info',
        path: '/price/inpry/voucher/detail',
        pathOld: '/price/inpry/info',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '询价单详情',
        data: function () {
            return {
                priceInpryInfo: {},
                id: null,
                radio: null,
                tableData: null,

                comparedTradeRuleList: [],
                type: 'priceInqry',
                tradeOperate: 'chakan',
                forPriceInqry: true,
                forGoods: null,
                forServc: null,
            }
        },
        created: function () {
            let self = this;
            let id = this.$route.query.id;
            self.id = id;
            self.getPriceInpryApi();
        },
        methods: {
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            },
            toPriceComparison: function (id, skuId) {
                this.$router.push({
                    path: SwbPriceComparison.path,
                    query: {
                        id: id,
                        skuId: skuId
                    }
                });
            },
            toServcComparison: function (id, ssuId) {
                this.$router.push({
                    path: SwbServcComparison.path,
                    query: {
                        id: id,
                        ssuId: ssuId
                    }
                });
            },
            // 获取询价信息
            getPriceInpryApi: function () {
                let self = this;
                let id = this.$route.query.id;
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceInqryVoucher(id, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let data = result.data;
                        if(data != null) {
                            self.priceInpryInfo = data;
                            if(data.goodsFlag) {
                                self.forGoods = true;
                            }
                            if(data.servcFlag) {
                                self.forServc = true;
                            }
                        }
                        self.getTradeRuleInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getTradeRuleInfo: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.id;
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceInqryTermList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let priceInqryTermList = result.data;
                        if(priceInqryTermList != null && priceInqryTermList.length > 0) {
                            self.comparedTradeRuleList = priceInqryTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                        }
                    }
                });
            },
            goBack: function () {
                let checkState = this.$route.query.checkState;
                this.$router.push({
                    path: SwbPriceInpryList.path,
                    query: {
                        checkState: checkState,
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceInpryInfo.vue